import { html } from "lit";
var icon_help_default = () => html`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
      fill-rule="evenodd"
      d="M16 2c7.732 0 14 6.268 14 14s-6.268 14-14 14S2 23.732 2 16 8.268 2 16 2zm0 2C9.373 4 4 9.373 4 16s5.373 12 12 12 12-5.373 12-12S22.627 4 16 4zm-.13 17.635a1.16 1.16 0 011.157 1.182c0 .626-.545 1.183-1.158 1.183-.68 0-1.158-.557-1.158-1.183 0-.695.477-1.182 1.158-1.182zM15.87 8c2.587 0 4.63 2.226 4.63 4.87 0 1.947-1.09 3.756-2.792 4.521-.613.279-1.022.835-1.022 1.53v.349c0 .487-.34.904-.817.904-.477 0-.885-.417-.885-.904v-.418c0-1.322.749-2.574 2.043-3.13 1.09-.487 1.77-1.6 1.77-2.852 0-1.67-1.293-3.061-2.928-3.061-1.226 0-2.247.695-2.724 1.808-.136.418-.68.626-1.09.487-.476-.208-.68-.765-.476-1.182C12.328 9.182 13.962 8 15.869 8z" />
  </svg>
`;
export {
  icon_help_default as default
};
//# sourceMappingURL=icon-help.js.map
